import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },

  icon: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    padding: theme.spacing(0.5),
    backgroundColor: theme.palette.secondary.dark,
    borderRadius: theme.spacing(2),
    marginRight: theme.spacing(1),

    '&img': {
      width: '100%',
    },
  },
}));
